export default function WhatsAppButton() {
  const phoneNumber = "21612345678"; // Remplacer par le vrai numéro
  const message = "Bonjour P'tit Voyou, j'ai une question...";
  
  const handleClick = () => {
    window.open(`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`, '_blank');
  };

  return (
    <button
      onClick={handleClick}
      className="fixed bottom-6 right-6 z-40 w-14 h-14 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-lg flex items-center justify-center transition-all duration-300 hover:scale-110 cursor-pointer"
      aria-label="Contact WhatsApp"
    >
      <i className="ri-whatsapp-line text-3xl"></i>
    </button>
  );
}